import React from 'react';
import classNames from 'classnames';

import ErrorMessage from 'components/Common/Formik/ErrorMessage/ErrorMessage';
import TurnstileFormikField, {
  Props as TurnstileFieldProps,
  TurnstileRef,
} from './TurnstileFormikField';

import styles from 'components/Common/Formik/Row/FormikTextRow.module.scss';

type Props = TurnstileFieldProps & {
  classes?: {
    row?: string;
    errorMessage?: string;
  };
};

export default function TurnstileFormikRow({
  name = 'turnstileToken',
  classes,
  ...props
}: Props): JSX.Element {
  return (
    <div className={classes?.row}>
      <TurnstileFormikField name={name} {...props} />
      <ErrorMessage
        name={name}
        additionalClass={classNames(styles.errorMessage, classes?.errorMessage)}
      />
    </div>
  );
}

export type { TurnstileRef };
